import React from 'react'
import ReactDOM from 'react-dom'
import { Router, Route, Switch } from 'react-router-dom'
import createBrowserHistory from 'history/createBrowserHistory'
import { Provider } from 'react-redux'
import { ApolloProvider } from 'react-apollo'

// Sentry Error Tracking
import './utils/sentry'

// Styles
import './index.css'
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css'
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css'
// Import Main styles for this application
import './scss/style.css'

// Containers
import App from './containers/App'
import Login from './containers/Login'

// Redux Store
import { store, DevTools } from './stores/reduxStore' // eslint-disable-line

// Apollo GraphQL
import apollo_client from './utils/apollo'

// Auth Wrapper Helpers
import { userIsAuthenticatedRedir, userIsNotAuthenticatedRedir } from './utils/authWrapper'

import registerServiceWorker from './registerServiceWorker'

import TagManager from 'react-gtm-module'

// Google Tag Manager
const hostname = window && window.location && window.location.hostname
if (/weldingo\.com$/.test(hostname) && process.env[`REACT_APP_GTM_${/([a-zA-Z-]+).weldingo.com/.exec(hostname)[1].toUpperCase().replace("-", '_')}`]) {
  const tagManagerArgs = {
    gtmId: process.env[`REACT_APP_GTM_${/([a-zA-Z-]+).weldingo.com/.exec(hostname)[1].toUpperCase().replace("-", '_')}`]
  }
  TagManager.initialize(tagManagerArgs)
}

// Need to apply the hocs here to avoid applying them inside the render method
const LoginComponent = userIsNotAuthenticatedRedir(Login)
const ProtectedComponent = userIsAuthenticatedRedir(App)

const customHistory = createBrowserHistory()

ReactDOM.render((
  <ApolloProvider client={apollo_client}>
    <Provider store={store}>
      <Router history={customHistory}>
        <div>
          {/*<DevTools/>*/}
          <Switch>
            <Route exact path="/login" name="Login" component={LoginComponent} />
            <Route path="/" name="Home" component={ProtectedComponent} />
          </Switch>
        </div>
      </Router>
    </Provider>
  </ApolloProvider>
), document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js